import { getSessionUUID } from '../components/lib/AuthToken';
import logger from "../utils/logger";


export const fetch_fuel_logs = async (dateRange) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(dateRange),
        };

        const response = await fetch('/fuel_logs/get_fuel_logs', requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching fuel logs:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const update_fuel_log = async (logId, data) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(data),
        };

        const response = await fetch(`/fuel_logs/update_fuel_log/${logId}`, requestOptions);
        const responseBody = await response.json();

        return {
            message: response.ok ? 'Update successful' : 'Update failed',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error updating fuel log:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const get_last_fuel_log = async (vehicleId, fuelType) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        const response = await fetch(`/fuel_logs/last_fuel_log/${vehicleId}/${fuelType}`, requestOptions);
        if (response.status === 204) return { status: 204, data: null };
        const responseBody = await response.json();

        return {
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching last fuel log:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const add_fuel_log = async (data) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(data),
        };

        const response = await fetch('/fuel_logs/add_fuel_log', requestOptions);
        const responseBody = await response.json();

        return {
            message: response.ok ? 'Created successfully' : 'Create failed',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error adding fuel log:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};
